module.exports = __webpack_public_path__ + "d6f4458d06fcb9c644e6aedc40528a.png";